import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { RequestHeaderModel } from 'src/app/models/request-header.model';
import { RequestLineModel } from 'src/app/models/request-line.model';
import {
  MenuItem,
  MenuSection,
  TitleAndDescription,
} from 'src/app/models/rich-data.model';
import { CaptionPipe } from 'src/app/pipes/caption.pipe';
import { AuthService } from 'src/app/services/auth.service';
import { AwsService } from 'src/app/services/aws.service';
import { DataService } from 'src/app/services/data.service';
import { RequestService } from 'src/app/services/request.service';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { TaskTypeService } from 'src/app/services/task-type.service';
import { TaskType } from 'src/app/models/task-type.model';
import { BuildingService } from 'src/app/services/building.service';
import { HotelBuilding } from 'src/app/models/building.model';
import { TranslateService } from '@ngx-translate/core';
import { ToastMachineService } from 'src/app/services/toast-machine.service';
import { GetTranslationService } from 'src/app/services/get-translation.service';

@Component({
  selector: 'app-request-form',
  templateUrl: './request-form.component.html',
  styleUrls: ['./request-form.component.scss'],
})
export class RequestFormComponent implements OnInit {
  @Input() sectionData: MenuSection;
  @Input() itemData: MenuItem;
  @Input() serviceData: TitleAndDescription;
  today = new Date().toTimeString().slice(0, 5);
  photo: string = null;
  type = '';
  quantity = 1;
  isValid = true;

  processing = false;

  constructor(
    private mdlctrl: ModalController,
    public dataServ: DataService,
    public authServ: AuthService,
    private caption: CaptionPipe,
    private requestServ: RequestService,
    private awsServ: AwsService,
    private router: Router,
    private platform: Platform,
    private typeServ: TaskTypeService,
    private buildingServ: BuildingService,
    private translator: GetTranslationService,
    private toaster: ToastMachineService
  ) {}

  ngOnInit() {
    this.authServ.control();
  }

  async close() {
    await this.mdlctrl.dismiss();
  }

  uploadPhoto(file: File) {
    const READER = new FileReader();
    READER.onload = () => {
      this.photo = READER.result as string;
    };

    READER.readAsDataURL(file);
  }

  async takePicture(inputEl: HTMLInputElement) {
    if (this.platform.is('capacitor')) {
      const image = await Camera.getPhoto({
        quality: 50,
        allowEditing: false,
        resultType: CameraResultType.DataUrl,
        presentationStyle: 'popover',
        saveToGallery: true,
        source: CameraSource.Prompt,
        promptLabelHeader: ' ',
      });
      this.photo = image.dataUrl;
    } else {
      inputEl.click();
    }
  }

  checkFormFieldsValidation() {
    if (this.dataServ.menuItem.form_fields) {
      for (
        let index = 0;
        index < this.dataServ.menuItem.form_fields.length;
        index++
      ) {
        const field = this.dataServ.menuItem.form_fields[index];

        if (field.is_required) {
          if (
            field.value === undefined ||
            field.value === null ||
            field.value === ''
          ) {
            this.isValid = false;

            const el = document.getElementById('form-' + index);
            if (el) {
              el.scrollIntoView({ behavior: 'smooth' });
              el.classList.add('error');
            }

            break; // Döngüden çık
          } else {
            const el = document.getElementById('form-' + index);
            if (el) {
              el.classList.remove('error');
            }
            this.isValid = true;
          }
        }
      }
    }
  }

  async send(note: string) {
    this.processing = true;
    this.authServ.control();

    this.checkFormFieldsValidation();

    if (!this.isValid) {
      const MSG = await this.translator.getTranslate('Please fill in the required fields');
      this.toaster.toastMachine(MSG, 'danger', 3000);

      this.processing = false;
      return;
    }

    if (this.authServ.isLogged) {
      if (!this.authServ.profile || this.authServ.profile?.id === 0) {
        await this.authServ.getMe();
      }

      let reqtype = null;

      if (this.sectionData.id === 114) {
        reqtype = 'Housekeeping';
      } else if (this.sectionData.id === 115) {
        reqtype = 'Issues';
      } else if (this.sectionData.id === 126) {
        reqtype = 'Reception';
      } else if (this.sectionData.id === 131) {
        reqtype = 'Guest Relation';
      } else if (this.sectionData.id === 113) {
        reqtype = 'Amenities';
      }

      let taskType: TaskType = null;
      let building: HotelBuilding = null;

      if (this.serviceData.task_type_id) {
        taskType = await this.typeServ.getType(this.serviceData.task_type_id);
        building = (await this.buildingServ.getBuildings()).find(
          (b) => b.name === this.authServ.profile.room_no
        );
      }

      const HEADER = new RequestHeaderModel(
        this.authServ.profile,
        note,
        reqtype,
        reqtype,
        this.itemData,
        this.caption.transform(
          this.sectionData.title,
          this.dataServ.rData.hotel_language || 'tr'
        ),
        this.caption.transform(
          this.sectionData.menu_categories.find(
            (x) => x.id === this.itemData.menu_category_id
          ).title,
          this.dataServ.rData.hotel_language || 'tr'
        ),
        this.caption.transform(
          this.itemData.name,
          this.dataServ.rData.hotel_language || 'tr'
        ),
        new Date(),
        this.dataServ.menuItem.form_fields,
        this.caption.transform(
          this.serviceData.title,
          this.dataServ.rData.hotel_language || 'tr'
        ),
        taskType,
        building
      );

      const LINE = new RequestLineModel(
        1,
        HEADER,
        'Title & Description',
        this.caption.transform(
          this.serviceData.title,
          this.dataServ.rData.hotel_language || 'tr'
        ),
        this.caption.transform(
          this.itemData.name,
          this.dataServ.rData.hotel_language || 'tr'
        ),
        this.type,
        this.quantity,
        0,
        '',
        '',
      );

      HEADER.requestlines.push(LINE);

      try {
        const RESP = await this.requestServ.postrequest([HEADER]);

        if (this.photo) {
          await this.awsServ.uploadRequestPhoto(
            this.photo,
            RESP[0].id,
            Boolean(taskType)
          );
        }

        this.close();
        const URL = this.router.url.split('/');

        URL.shift();

        const routeUrl = '/' + URL[0];
        this.router.navigateByUrl(routeUrl);
      } catch {}
    }

    this.processing = false;
  }
}
